<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Лабораторные исследования</h1>
      </v-col>

      <v-col align="right">
        <!--        <modal depressed icon="add" title="Добавить документ" name="Документ" component="add-document"></modal>-->
        <v-btn depressed color="primary" title="title" @click.prevent="addDocument">
          <v-icon left>add</v-icon>
          Исследование
        </v-btn>
      </v-col>
    </v-row>

    <patient-header />
    <analyz-document-list />
  </v-container>
</template>

<script>
import AnalyzDocumentList from "./components/AnalyzDocumentList";
import Modal from "@/components/Modal";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import "@/plugins/crypto-pro-loader.js";
import PatientHeader from "@/components/PatientHeader";
export default {
  components: {
    Modal,
    AnalyzDocumentList,
    PatientHeader,
  },
  methods: {
    addDocument() {
      this.$dialog.showAndWait(AddDocument, { width: "600px", persistent: true, formCategory: 2 });
    },
  },
};
</script>

<style></style>
